import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const ConfirmModal = (props) => {
  const [show, setShow] = useState(props.show);

  useEffect(() => {
    setShow(props.show)
  }, [props.show])

  const getActionText = () => {
    if (props.type === 'restore') return 'restore';
    if (props.type === 'permanentDelete') return 'permanently delete';
    if (props.type === 'inactive') return 'inactive';
    if (props.type === 'active') return 'active';
    return 'delete';
  }

  const moduleName = props.module ? props.module : "record";
    
  // Special phrasing for active/inactive
  const isActivate = props.type === 'active' || props.type === 'activate';
  const isDeactivate = props.type === 'inactive' || props.type === 'deactivate';

  const defaultMessage = isActivate
    ? `Are you sure you want to mark this ${moduleName} as active?`
    : isDeactivate
      ? `Are you sure you want to mark this ${moduleName} as inactive?`
      : `Are you sure you want to ${getActionText()} this ${moduleName}?`;
  
  return (
    <React.Fragment>
      <Modal show={show} onHide={props.onCloseModal}>
        {/* <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header> */}
        <Modal.Body className="p-4">
          {props.customMessage && props.customMessage !== '' &&
            <>
              {props.customMessage}
            </>
          }
          {!props.customMessage &&
            <>
              {/* Are you sure you want to {props.type === 'restore' ? "restore" : (props.type === 'permanentDelete' ? "permanently delete" : "delete")} this {props.module ? props.module : "record"}? */}
              {defaultMessage}
            </>
          }
        </Modal.Body>


        <Modal.Footer>
          {!props.showCancelButton && props.showCancelButton !== false &&
            <Button variant="secondary" onClick={props.onCloseModal}>
              Cancel
            </Button>
          }
          {props.deleteLoading && props.deleteLoading === false &&
            <Button variant="secondary" className="btn btn-orange btn-cfm" onClick={props.confirmClick}>
              {(!props.confirmBtnText || props.confirmBtnText === "") ? "Confirm" : props.confirmBtnText}
            </Button>
          }
          {props.deleteLoading && props.deleteLoading === true &&
            <Button className="btn btn-sm btn-blue" variant="secondary">
              <Spinner animation="border" size="sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </Button>
          }
          {!props.deleteLoading &&
            <Button variant="secondary" className="btn btn-orange btn-cfm " onClick={props.confirmClick}>
              {(!props.confirmBtnText || props.confirmBtnText === "") ? "Confirm" : props.confirmBtnText}
            </Button>
          }
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}
export default ConfirmModal;